import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, aspectWidth, aspectHeight } = props;
  const images = listing.images;
  // Use the same variant family the ListingCard uses so images reliably exist across pages
  const imageVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  const thumbnailVariants = imageVariants;
  return (
    <div className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        aspectWidth={aspectWidth}
        aspectHeight={aspectHeight}
      />
    </div>
  );
};

export default SectionGallery;
